import { useEffect } from 'react';

import { hasFeatureAddOnAccess } from '@/shared/entitlements';
import { useBillingStore } from '@/stores/database/aliases/billing';

export const useBillingSnapshot = () => {
    // Core
    const snapshot = useBillingStore((s) => s.snapshot);
    const loading = useBillingStore((s) => s.loading);
    const mutating = useBillingStore((s) => s.mutating);
    const fetchSnapshot = useBillingStore((s) => s.fetchSnapshot);

    useEffect(() => {
        fetchSnapshot();
    }, [fetchSnapshot]);

    // Derivations

    const status = snapshot?.subscription?.status;
    const relationsEnabled = hasFeatureAddOnAccess(snapshot, 'relations');
    const lifecyclesEnabled = hasFeatureAddOnAccess(snapshot, 'lifecycles');

    return {
        snapshot,
        loading,
        mutating,
        isBlocked: status === 'past_due',
        isCanceled: status === 'canceled',
        isTrial: status === 'trialing',
        isActive: status === 'active',
        lifecyclesEnabled,
        relationsEnabled,
    };
};
